module.exports = __webpack_public_path__ + "static/media/ic_store.c0464c1b.svg";